import React, { useEffect, ReactNode } from "react";
import { IoClose } from "react-icons/io5";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: ReactNode;
  isHE?: boolean;
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, title, children, isHE = false }) => {
  // Close on Escape key
  useEffect(() => {
    if (!isOpen) return;
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleKey);
    // Prevent background scroll while modal is open
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", handleKey);
      document.body.style.overflow = "";
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm animate-fade-in"
      onClick={onClose}
      dir={isHE ? "rtl" : "ltr"}
    >
      <div
        className="relative flex max-h-[85vh] w-full max-w-2xl flex-col rounded-2xl border border-white/10 bg-[#191C22] shadow-elevation-lg ring-1 ring-white/5"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        {/* Header */}
        <div className="flex items-center justify-between gap-4 border-b border-white/10 px-6 py-4">
          <h2 className="text-lg font-bold" style={{ color: "#F88158" }}>
            {title}
          </h2>
          <button
            onClick={onClose}
            aria-label={isHE ? "סגור" : "Close"}
            className="rounded-full p-1.5 text-gray-300 transition hover:bg-white/10 hover:text-white active:scale-95"
          >
            <IoClose size={22} />
          </button>
        </div>

        {/* Scrollable body */}
        <div className="overflow-y-auto px-6 py-5 text-sm leading-relaxed text-gray-200">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
